import { Puzzle, Stack } from "components/icons/generated";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellLink from "ds/components/Table/Row/CellLink";

import EnvironmentTableCell from "../Cell";
import { EnvironmentVariableCellProps } from "./types";

const SourceCell = ({ item, ...cellProps }: EnvironmentVariableCellProps) => {
  const dependencyStack = item.stackDependency?.dependsOnStack;
  const context = item.context;

  return (
    <EnvironmentTableCell {...cellProps}>
      {dependencyStack && (
        <TableCellLink href={`/stack/${dependencyStack.id}/dependencies`} startIcon={Stack}>
          {dependencyStack.name}
        </TableCellLink>
      )}
      {!dependencyStack && context && (
        <TableCellLink href={`/context/${context.contextId}`} startIcon={Puzzle}>
          {context.contextName}
        </TableCellLink>
      )}
      {!dependencyStack && !context && <TableCellEmpty />}
    </EnvironmentTableCell>
  );
};

export default SourceCell;
